import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  getDoc,
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

// ==================== ASSIGNMENTS ====================

export const createAssignment = async (userId, assignmentData) => {
  try {
    const assignmentsRef = collection(db, 'assignments');
    const docRef = await addDoc(assignmentsRef, {
      ...assignmentData,
      userId,
      createdAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating assignment:', error);
    return { success: false, error };
  }
};

export const getAssignments = async (userId) => {
  try {
    const assignmentsRef = collection(db, 'assignments');
    const q = query(
      assignmentsRef,
      where('userId', '==', userId),
      orderBy('dueDate', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const assignments = [];
    querySnapshot.forEach((doc) => {
      assignments.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, assignments };
  } catch (error) {
    console.error('Error getting assignments:', error);
    return { success: false, error };
  }
};

export const getAssignment = async (assignmentId) => {
  try {
    const assignmentRef = doc(db, 'assignments', assignmentId);
    const assignmentSnap = await getDoc(assignmentRef);

    if (!assignmentSnap.exists()) {
      return { success: false, error: 'Assignment not found' };
    }

    return { success: true, assignment: { id: assignmentSnap.id, ...assignmentSnap.data() } };
  } catch (error) {
    console.error('Error getting assignment:', error);
    return { success: false, error };
  }
};

export const updateAssignment = async (assignmentId, assignmentData) => {
  try {
    const assignmentRef = doc(db, 'assignments', assignmentId);
    await updateDoc(assignmentRef, {
      ...assignmentData,
      updatedAt: serverTimestamp()
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating assignment:', error);
    return { success: false, error };
  }
};

export const deleteAssignment = async (assignmentId) => {
  try {
    const assignmentRef = doc(db, 'assignments', assignmentId);
    await deleteDoc(assignmentRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting assignment:', error);
    return { success: false, error };
  }
};

// Get assignments by unit
export const getAssignmentsByUnit = async (userId, unitId) => {
  try {
    const assignmentsRef = collection(db, 'assignments');
    const q = query(
      assignmentsRef,
      where('userId', '==', userId),
      where('unitId', '==', unitId),
      orderBy('dueDate', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const assignments = [];
    querySnapshot.forEach((doc) => {
      assignments.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, assignments };
  } catch (error) {
    console.error('Error getting assignments by unit:', error);
    return { success: false, error };
  }
};

// Get assignments by lesson
export const getAssignmentsByLesson = async (userId, lessonId) => {
  try {
    const assignmentsRef = collection(db, 'assignments');
    const q = query(
      assignmentsRef,
      where('userId', '==', userId),
      where('lessonId', '==', lessonId),
      orderBy('dueDate', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const assignments = [];
    querySnapshot.forEach((doc) => {
      assignments.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, assignments };
  } catch (error) {
    console.error('Error getting assignments by lesson:', error);
    return { success: false, error };
  }
};
